import Network from "../../../../../services/Network";
import { POST_PROPERTY, FETCH_PROPERTY_BASIC_INFO } from "../../../../../utils/endpoints";

export const fetchPropertyDetails = (id, resolve, reject) => Network.GET(FETCH_PROPERTY_BASIC_INFO + id, null, null, resolve, reject);

export const createProperty = (data, resolve, reject) => Network.POST(POST_PROPERTY, null, data, null,
    response => resolve(response.property_unique_id),
    reject
);